module.exports = "<mat-slider></mat-slider>"